import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactTypeGroup extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactTypeGroup';
    }

    public clone(): any {
        return new CNContactTypeGroup();
    }
}
